// import { useNavigate } from 'react-router';
import React, { useState, useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
// import { DataGrid } from '@mui/x-data-grid';
// import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';

import Header from '../components/Header';
import Footer from '../components/Footer';

import { fetchToken } from '../components/Auth';
import { useGetApi } from '../components/ApiAccess';
import { formatErrorMessage } from '../components/FormatErrorMassage';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendar
} from '@fortawesome/free-regular-svg-icons';

const convertToDateOnly = (dateTimeString) => {
  if (!dateTimeString) return '';
  return dateTimeString.split('T')[0];
};

const convertToDatetime = (dateString) => {
  if (!dateString) return null;

  const date = new Date(dateString + 'T00:00:00');
  date.setHours(23, 59, 59, 0);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
};

export default function ManageApiKey() {
  const params = useParams();
  const [errorResult, setErrorResult] = useState('');

  const [apiKeyInfo, setApiKeyInfo] = useState({
    is_active: false,
    expires_at: null,
    items: [],
  });
  const [tempStatus, setTempStatus] = useState(true);
  const [tempDatetime, setTempDatetime] = useState('');
  const [tempCreate, setTempCreate] = useState({ memo: '', expires_at: '' });

  const getApiKey = useGetApi('/api/v1/apiKey/?id=' + params.clientId);

  const handleGetApiKey = () => {
    getApiKey().then((response) => {
      setApiKeyInfo(response.data);
      setTempStatus(response.data.is_active);
      setTempDatetime(convertToDateOnly(response.data.expires_at));
      setTempCreate({ memo: '', expires_at: '' });
      setErrorResult('');
    });
  };

  useEffect(() => {
    if (params.clientId) {
      handleGetApiKey();
    }
  }, []);

  const headers = {
    accept: 'application/json',
    Authorization: 'Bearer ' + fetchToken(),
  };

  const putApiKey = (putData) => {
    axios
      .put('/api/v1/apiKey/', putData, { headers: headers })
      .then((res) => {
        handleGetApiKey();
      })
      .catch((error) => {
        const newErrorResult = formatErrorMessage(error.response?.data);
        setErrorResult(newErrorResult);
      });
  };

  const postApiKey = (postData) => {
    axios
      .post('/api/v1/apiKey/', postData, { headers: headers })
      .then((res) => {
        // テキストファイルのダウンロード
        const textContent = `key: ${res.data.api_key}\nmemo: ${res.data.memo}`;
        const blob = new Blob([textContent], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `qr-react-app-apikey_${params.clientId}-${apiKeyInfo.items.length + 1}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        handleGetApiKey();
      })
      .catch((error) => {
        const newErrorResult = formatErrorMessage(error.response?.data);
        setErrorResult(newErrorResult);
      });
  };

  const [modal, setModal] = useState(null);

  const handleModalStatus = () => {
    setTempStatus(!apiKeyInfo.is_active);
    setModal('status');
  };
  const handleUpdateStatus = () => {
    let putData = {
      id: params.clientId,
      is_active: tempStatus,
    };
    putApiKey(putData);
    setModal(false);
  };

  const handleModalDate = () => {
    setModal('date');
  };
  const handleChangeDate = (e) => {
    setTempDatetime(e.target.value);
  };
  const handleClearDate = () => {
    setTempDatetime('');
  };
  const handleUpdateDate = () => {
    let putData = {
      id: params.clientId,
      expires_at: convertToDatetime(tempDatetime),
    };
    putApiKey(putData);
    setModal(false);
  };

  const handleModalCreate = () => setModal('create');
  const handleChangeCreateMemo = (e) => {
    setTempCreate({ ...tempCreate, memo: e.target.value });
  };
  const handleChangeCreateDate = (e) => {
    setTempCreate({ ...tempCreate, expires_at: e.target.value });
  };
  const handleClearCreateDate = () => {
    setTempCreate({ ...tempCreate, expires_at: '' });
  };
  const handleCreate = () => {
    let postData = {
      id: params.clientId,
      memo: tempCreate.memo,
      expires_at: convertToDatetime(tempCreate.expires_at),
    };
    postApiKey(postData);
    setModal(false);
  };

  const handleClose = () => {
    setModal(false);
  };

  return (
    <div className={'manage-api-key'}>
      <Header />
      <main>
        <Container>
          <h2>APIキー管理</h2>
          {errorResult && (
            <Alert key={'danger'} variant={'danger'} className='error-result-message'>
              エラー:
              <br />
              {errorResult.map((htmlString, index) => (
                <React.Fragment key={index}>
                  {htmlString}
                  <br />
                </React.Fragment>
              ))}
            </Alert>
          )}

          <div className={'form-wrapper api-key'}>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="h5">ステータス</Form.Label>
                <Col>
                  <span>使用可否</span>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    className={'toggle-switch aaa'}
                  >
                    <Form.Check.Input
                      className="toggle-switch-checkbox"
                      checked={apiKeyInfo.is_active}
                      onChange={handleModalStatus}
                      disabled={apiKeyInfo.is_active === null}
                    ></Form.Check.Input>
                    <Form.Check.Label className="toggle-switch-label">
                      <span className="toggle-switch-inner" />
                      <span className="toggle-switch-switch" />
                    </Form.Check.Label>
                  </Form.Check>
                </Col>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="h5">利用期限</Form.Label>
                <div className="text-wrap">
                  <Form.Control
                    type="text"
                    value={
                      apiKeyInfo.expires_at === null
                        ? '未設定'
                        : new Date(apiKeyInfo.expires_at).toLocaleString()
                    }
                    onClick={handleModalDate}
                    readOnly
                    disabled={apiKeyInfo.is_active === null}
                  />
                  <FontAwesomeIcon icon={faCalendar} className="icon manage-api-key-icon" />
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <div className="text-end">
                  <Button variant="dark" onClick={handleModalCreate}>
                    新たにAPIキーを生成する
                  </Button>
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <table className="w-100 manage-api-key-table">
                  <thead>
                    <tr>
                      <th className='header-id'>ID</th>
                      <th>メモ</th>
                      <th className='header-generator'>生成日</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiKeyInfo['items'] && (
                      <>
                        {apiKeyInfo['items'].map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{apiKeyInfo['items'].length - index}</td>
                              <td>
                                {item.memo}
                              </td>
                              <td>{new Date(item.created_at).toLocaleString().split(' ')[0]}</td>
                            </tr>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                </table>
              </Form.Group>
            </Form>
          </div>
        </Container>
      </main>
      <Footer />

      <Modal
        show={modal === 'status'}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="api-key-modal"
      >
        <Modal.Header className="border-0">
          <Modal.Title className="h5 fw-bold">
            {apiKeyInfo.is_active ? (
              <>APIキーの使用を制限します。</>
            ) : (
              <>APIキーの使用を許可します。</>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            APIキーの利用ステータスを変更します。
            <br />
            {apiKeyInfo.is_active ? (
              <>使用不可にすると企業に紐づくAPIの利用ができなくなります。</>
            ) : (
              <>
                使用可にすることでAPIをご利用いただけます。
                <br />
                最後に生成したAPIキーのみ有効です。
              </>
            )}
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center border-0 api-key-modal-footer">
          <Button variant="dark" onClick={handleClose}>
            閉じる
          </Button>
          <Button variant="primary" onClick={handleUpdateStatus}>
            更新
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modal === 'date'}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="api-key-modal"
      >
        <Modal.Header className="border-0">
          <Modal.Title className="h5 fw-bold">APIキーの期限を設定します。</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>利用期限を入力してください。</p>
          <Form className="mb-3">
            <Form.Group
              controlId="datetime"
              className="d-flex justify-content-between align-items-center"
            >
              <Form.Label className="mb-0">利用期限</Form.Label>
              <div className="api-key-modal-body">
                <Form.Control
                  type="date"
                  value={tempDatetime}
                  onChange={(value) => handleChangeDate(value)}
                />
                <Button variant="dark" onClick={handleClearDate}>
                  ✕
                </Button>
              </div>
            </Form.Group>
          </Form>
          <p>
            設定された日付の23:59:59まではAPIの利用が可能です。
            <br />
            この設定はいつでも変更できます。
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center border-0 api-key-modal-footer">
          <Button variant="dark" onClick={handleClose}>
            閉じる
          </Button>
          <Button variant="primary" onClick={handleUpdateDate}>
            更新
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modal === 'create'}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="api-key-modal"
      >
        <Modal.Header className="border-0">
          <Modal.Title className="h5 fw-bold">新たにAPIキーを生成する</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>キーの識別を行うためにメモと合わせて登録を行なってください。</p>
          <Form className="mb-3">
            <Form.Group controlId="memo" className="mb-3">
              <Form.Control
                as="textarea"
                rows={5}
                maxLength={255}
                value={tempCreate.memo}
                onChange={(value) => handleChangeCreateMemo(value)}
              />
            </Form.Group>
            <Form.Group
              controlId="datetime"
              className="d-flex justify-content-between align-items-center"
            >
              <Form.Label className="mb-0">利用期限</Form.Label>
              <div className="api-key-modal-body">
                <Form.Control
                  type="date"
                  value={tempCreate.expires_at}
                  onChange={(value) => handleChangeCreateDate(value)}
                />
                <Button variant="dark" onClick={handleClearCreateDate}>
                  ✕
                </Button>
              </div>
            </Form.Group>
          </Form>
          <p className='api-key-modal-caution'>
            ※キーの再発行を行うと以前に発行済みのAPIキーは無効となります。
          </p>
          <p className='api-key-modal-caution'>
            ※「生成」を押すとテキストファイルをダウンロードします。
            <br />
            　テキストファイルは大切に保管してください。
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center border-0 api-key-modal-footer">
          <Button variant="dark" onClick={handleClose} >
            閉じる
          </Button>
          <Button variant="primary" onClick={handleCreate}>
            生成
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
